import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Estádio Allianz Parque/allianz.jpg';
import imagem2 from '../assets/images/Projetos/Estádio Allianz Parque/allianz-parque2.jpeg';
import imagem3 from '../assets/images/Projetos/Estádio Allianz Parque/allianz-parque3.jpg';

const App = () => {
  const projectData = {
    date: "26/03/2018",
    title: "Estádio Allianz Parque",
    images: [
      imagem1,
      imagem2,
      imagem3
    ],
    description:
    "Para o projeto do Estádio do Allianz Parque participamos diretamente com as soluções abaixo:",
    solutions: ["Solução de Cobertura Indoor, CFTV, Detecção de Incêndio"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;